//@ts-check
import { makeObservable, observable, action } from 'mobx';
import DocumentHistoryRequests from 'Utils/Requests/DocumentHistoryRequests';
import Helper from "Utils/Helper";

class FiltersStore {
    initDataLoading;
    /** @type {DocumentHistoryFiltersValues} */
    filtersValues;
    /** @type {DocumentDownloadFilterSet} */
    defaultFilter;
    /** @type {DocumentDownloadFilterSet} */
    filters;
    /** @type {DocumentDownloadFilterSet} */
    filtersRender;
    renderStore;

    constructor() {
        makeObservable(this, {
            initDataLoading: observable,
            filtersValues: observable,
            filters: observable,
            filtersRender: observable,
            renderStore: observable
        });
        this.initDataLoading = true;
        this.initDataLoaded = false;
        this.filtersValues = {};
        this.defaultFilter = {};
        this.filters = {};
        this.filtersRender = {};
        this.renderStore = {};
    }

    ClearFiltersRender = action(() => {
        let sortRules = this.filters.sortRules ?? Helper.CloneObject(this.defaultFilter.sortRules);
        this.filtersRender = Helper.CloneObject(this.defaultFilter);
        this.filtersRender.sortRules = sortRules;
        this.renderStore = {};
    });

    GetInitData() {
        if (this.initDataLoaded)
            return;

        DocumentHistoryRequests.GetInitData().then(action(values => {
            if (values.error)
                return;

            this.filtersValues = values.filtersValues;
            this.defaultFilter = values.defaultFilter;
            this.LoadDefaultFilters();

            this.initDataLoading = false;
            this.initDataLoaded = true;
        }));
    }

    ClearStore() {
        this.LoadDefaultFilters();

        this.initDataLoading = false;
        this.initDataLoaded = false;
    }

    LoadFiltersToRender() {
        this.filtersRender = Helper.CloneObject(this.filters);
    }

    SaveFiltersFromRender() {
        this.filters = Helper.CloneObject(this.filtersRender);
    }

    LoadDefaultFilters() {
        this.filters = Helper.CloneObject(this.defaultFilter);
        this.filtersRender = Helper.CloneObject(this.defaultFilter);
    }

    GetSelectedFiltersCount() {
        let filters = this.filters;

        return (filters.regNumAlias || filters.matchWholeWord ? 1 : 0) +
            (filters.includeInitiative ? 1 : 0) +
            (filters.regDateStart || filters.regDateEnd ? 1 : 0);
    }
}

export default new FiltersStore();